export const DOMAIN_CATEGORIES = [
  {
    id: 'general',
    path: 'general',
    label: 'label.GENERAL',
    items: [
      {
        id: 'general-domains',
        section: 'domains',
        label: 'label.DOMAINS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_DOMAINS'
      },
      {
        id: 'general-signatures',
        section: 'signatures',
        label: 'label.SIGNATURES',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_SIGNATURES',
        permission: 'staff'
      },
      {
        id: 'general-banners',
        section: 'banners',
        label: 'label.BANNERS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_BANNERS',
        permission: 'staff'
      },
      {
        id: 'general-bizcards',
        section: 'bizcards',
        label: 'label.BUSINESS_CARDS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.BUSINESS_CARDS',
        permission: 'staff'
      },
      {
        id: 'general-billing',
        section: 'billing',
        label: 'label.BILLING',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_BILLING',
        permission: 'staff'
      },
      {
        id: 'general-email',
        section: 'email',
        label: 'label.EMAIL_AND_TRACKING',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_EMAIL_AND_TRACKING',
        permission: 'staff'
      },
      {
        id: 'general-personas',
        section: 'personas',
        label: 'label.PERSONAS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_PERSONAS',
        permission: 'staff'
      },
      // {
      //   id: 'general-fusion',
      //   section: 'fusion',
      //   label: 'Fusion',
      //   nestedLabel: 'General: Fusion'
      // },
      {
        id: 'general-users',
        section: 'users',
        label: 'label.USERS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_USERS',
        permission: 'staff'
      },
      {
        id: 'general-audit-history',
        section: 'audit-history',
        label: 'label.AUDIT_HISTORY',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GENERAL_AUDIT_HISTORY',
        permission: 'staff'
      }
    ]
  },
  {
    id: 'branding',
    path: 'branding',
    label: 'label.BRANDING',
    permission: 'staff'
  },
  {
    id: 'routing',
    path: 'routing',
    label: 'label.ROUTING',
    permission: 'staff',
    items: [
      {
        id: 'routing-general',
        section: 'general',
        label: 'label.GENERAL',
        nestedLabel: 'label.DOMAIN_DROPDOWN.ROUTING_GENERAL'
      },
      {
        id: 'routing-smart',
        section: 'smart',
        label: 'label.SMART_HOST',
        nestedLabel: 'label.DOMAIN_DROPDOWN.ROUTING_SMART_HOST'
      },
      {
        id: 'routing-bulk',
        section: 'bulk',
        label: 'label.BULK_HOST',
        nestedLabel: 'label.DOMAIN_DROPDOWN.ROUTING_BULK_HOST'
      },
      {
        id: 'routing-relay',
        section: 'relay',
        label: 'label.RELAY',
        nestedLabel: 'label.DOMAIN_DROPDOWN.ROUTING_RELAY'
      }
    ]
  },
  {
    id: 'deliverabilty',
    path: 'deliverabilty',
    label: 'label.DELIVERABILITY',
    permission: 'staff'
  },
  {
    id: 'sso',
    path: 'sso',
    label: 'label.SSO',
    permission: 'staff',
    items: [
      {
        id: 'sso-authentication',
        section: 'authentication',
        label: 'label.AUTHENTICATION',
        nestedLabel: 'label.DOMAIN_DROPDOWN.SSO_AUTHENTICATION'
      },
      {
        id: 'sso-bindings',
        section: 'bindings',
        label: 'label.ROLE_BINDINGS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.SSO_ROLE_BINDINGS'
      },
      {
        id: 'sso-saml',
        section: 'saml',
        label: 'label.SAML',
        nestedLabel: 'label.DOMAIN_DROPDOWN.SSO_SAML'
      }
    ]
  },
  {
    id: 'crm',
    path: 'crm',
    label: 'label.CRM',
    items: [
      {
        id: 'crm-salesforce',
        section: 'salesforce',
        label: 'label.SALESFORCE',
        nestedLabel: 'label.DOMAIN_DROPDOWN.CRM_SALESFORCE'
      },
      {
        id: 'crm-surefire',
        section: 'surefire',
        label: 'label.SUREFIRE',
        nestedLabel: 'label.DOMAIN_DROPDOWN.CRM_SUREFIRE'
      },
      {
        id: 'crm-totalexpert',
        section: 'totalexpert',
        label: 'label.TOTAL_EXPERT',
        nestedLabel: 'label.DOMAIN_DROPDOWN.CRM_TOTAL_EXPERT'
      }
    ]
  },
  {
    id: 'marketing',
    path: 'marketing',
    label: 'label.MARKETING'
  },
  {
    id: 'compliance',
    path: 'compliance',
    label: 'label.COMPLIANCE',
    permission: 'staff'
  },
  {
    id: 'outlookaddin',
    path: 'outlook',
    label: 'label.OUTLOOK_ADDIN',
    items: [
      {
        id: 'outlook-general',
        section: 'general',
        label: 'label.GENERAL',
        nestedLabel: 'label.DOMAIN_DROPDOWN.OUTLOOK_ADDIN_GENERAL',
        permission: 'microsoft'
      },
      {
        id: 'outlook-fields',
        section: 'fields',
        label: 'label.USER_AND_SIGNATURE_FIELDS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.OUTLOOK_ADDIN_USERS_AND_SIGNATURE_FIELDS',
        permission: 'microsoft'
      },
      {
        id: 'outlook-email-tracking',
        section: 'email-tracking',
        label: 'label.EMAIL_TRACKING',
        nestedLabel: 'label.DOMAIN_DROPDOWN.OUTLOOK_ADDIN_EMAIL_TRACKING',
        permission: 'microsoft'
      },
      {
        id: 'outlook-shared',
        section: 'shared',
        label: 'label.ALIASES_AND_SHARED_INBOXES',
        nestedLabel: 'label.DOMAIN_DROPDOWN.OUTLOOK_ADDIN_ALIASES_AND_SHARED_INBOXES',
        permission: 'microsoft'
      }
    ]
  },
  {
    id: 'gmailaddin',
    path: 'google',
    label: 'label.GOOGLE_ADDON',
    items: [
      // {
      //   id: 'google-general',
      //   section: 'general',
      //   label: 'label.GENERAL',
      //   nestedLabel: 'label.DOMAIN_DROPDOWN.GOOGLE_ADDON_GENERAL',
      //   permission: 'google'
      // },
      {
        id: 'google-fields',
        section: 'fields',
        label: 'label.USER_AND_SIGNATURE_FIELDS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.GOOGLE_ADDON_USERS_AND_SIGNATURE_FIELDS',
        permission: 'google'
      }
      // {
      //   id: 'google-email-tracking',
      //   section: 'email-tracking',
      //   label: 'label.EMAIL_TRACKING',
      //   nestedLabel: 'label.DOMAIN_DROPDOWN.GOOGLE_ADDON_EMAIL_TRACKING',
      //   permission: 'google'
      // },
      // {
      //   id: 'google-shared',
      //   section: 'shared',
      //   label: 'label.ALIASES_AND_SHARED_INBOXES',
      //   nestedLabel: 'label.DOMAIN_DROPDOWN.GOOGLE_ADDON_ALIASES_AND_SHARED_INBOXES',
      //   permission: 'google'
      // }
    ]
  },
  {
    id: 'signature',
    path: 'signature',
    label: 'label.MY_SIGNATURE'
  },
  {
    id: 'directory',
    path: 'directory',
    label: 'label.DIRECTORY_SYNC',
    items: [
      {
        id: 'directory-general',
        section: 'general',
        label: 'label.GENERAL',
        nestedLabel: 'label.DOMAIN_DROPDOWN.DIRECTORY_GENERAL'
      },
      {
        id: 'directory-microsoft',
        section: 'microsoft',
        label: 'label.MICROSOFT_365',
        permission: 'microsoft',
        nestedLabel: 'label.DOMAIN_DROPDOWN.DIRECTORY_MICROSOFT_365'
      },
      {
        id: 'directory-google',
        section: 'google',
        label: 'label.GOOGLE_WORKSPACE',
        permission: 'google',
        nestedLabel: 'label.DOMAIN_DROPDOWN.DIRECTORY_GOOGLE_WORKSPACE'
      },
      {
        id: 'directory-custom',
        section: 'custom',
        label: 'label.CUSTOM_DIRECTORY',
        nestedLabel: 'label.DOMAIN_DROPDOWN.DIRECTORY_CUSTOM_DIRECTORY'
      },
      {
        id: 'directory-sftp',
        section: 'sftp',
        label: 'SFTP',
        nestedLabel: 'label.DOMAIN_DROPDOWN.DIRECTORY_SFTP'
      },
      {
        id: 'directory-configurations',
        section: 'configurations',
        label: 'label.CONFIGURATIONS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.DIRECTORY_CONFIGURATIONS'
      }
    ]
  },
  {
    id: 'integrations',
    path: 'integrations',
    label: 'label.INTEGRATIONS',
    items: [
      {
        id: 'integrations-calendly',
        section: 'integrations',
        label: 'label.CALENDLY',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_CALENDLY'
      },
      {
        id: 'integrations-drift',
        section: 'integrations',
        label: 'label.DRIFT',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_DRIFT'
      },
      {
        id: 'integrations-eloqua',
        section: 'integrations',
        label: 'label.ELOQUA',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_ELOQUA'
      },
      {
        id: 'integrations-hubspot',
        section: 'integrations',
        label: 'label.HUBSPOT',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_HUBSPOT'
      },
      {
        id: 'integrations-marketo',
        section: 'integrations',
        label: 'label.MARKETO',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_MARKETO'
      },
      {
        id: 'integrations-outreach',
        section: 'integrations',
        label: 'label.OUTREACH',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_OUTREACH'
      },
      {
        id: 'integrations-pardot',
        section: 'integrations',
        label: 'label.PARDOT',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_PARDOT'
      },
      {
        id: 'integrations-rollworks',
        section: 'integrations',
        label: 'label.ROLLWORKS',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_ROLLWORKS'
      },
      {
        id: 'integrations-salesloft',
        section: 'integrations',
        label: 'label.SALESLOFT',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_SALESLOFT'
      },
      {
        id: 'integrations-ukg',
        section: 'integrations',
        label: 'label.UKG',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_UKG'
      },
      {
        id: 'integrations-zapier',
        section: 'integrations',
        label: 'label.ZAPIER',
        nestedLabel: 'label.DOMAIN_DROPDOWN.INTEGRATIONS_ZAPIER'
      }
    ]
  },
  {
    id: 'diagnostics',
    path: 'diagnostics',
    label: 'label.DIAGNOSTICS',
    permission: 'staff'
  }
];

export const DOMAIN_SETTINGS_SEARCH = [
  {
    id: 'General',
    groupHeader: true,
    label: 'label.GENERAL',
    selectable: false,
    value: 'General',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DOMAINS',
    value: 'general-domains',
    // description: 'Manage your domains and domain aliases.',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURES',
    value: 'general-signatures?item=Signatures',
    // description: 'Configure your signature settings.',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BANNERS',
    value: 'general-banners?item=Banners',
    // description: 'Configure your banner settings.',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'Business Cards',
    value: 'general-bizcards?item=Business Cards',
    // description: 'Configure your Business Card settings.',
    group: 'General',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'Billing',
    value: 'general-billing?item=Billing',
    // description: 'Configure your billing settings.',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.EMAIL_AND_TRACKING',
    value: 'general-email?item=Email & Tracking',
    // description: 'Configure your email and tracking settings.',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'Users',
    value: 'general-users?item=Users',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.AUDIT_HISTORY',
    value: 'general-audit-history?item=Audit History',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PERSONAS',
    value: 'general-personas?item=Personas',
    group: 'label.GENERAL',
    permission: 'staff'
  },
  {
    id: 'Branding',
    groupHeader: true,
    label: 'label.BRANDING',
    selectable: false,
    value: 'Branding',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRANDING',
    value: 'branding',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.COMPANY_NAME',
    value: 'branding?item=Company Name',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.COMPANY_URL',
    value: 'branding?item=Company URL',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.LOGO_URL',
    value: 'branding?item=Logo URL',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ICON_URL',
    value: 'branding?item=Icon URL',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_PRIMARY_COLOR',
    value: 'branding?item=Brand Primary Color',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_SECONDARY_COLOR',
    value: 'branding?item=Brand Secondary Color',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_TERTIARY_COLOR',
    value: 'branding?item=Brand Tertiary Color',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_BACKGROUND_COLOR',
    value: 'branding?item=Brand Background Color',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_TEXT_COLOR',
    value: 'branding?item=Brand Text Color',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_FONT_FAMILY',
    value: 'branding?item=Brand Font Family',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_FONT_WEIGHT',
    value: 'branding?item=Brand Font Weight',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_HEADER_FONT_FAMILY',
    value: 'branding?item=Brand Header Font Family',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BRAND_HEADER_FONT_WEIGHT',
    value: 'branding?item=Brand Header Font Weight',
    group: 'label.BRANDING',
    permission: 'staff'
  },
  {
    value: 'General → Domains',
    label: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    id: 'General → Domains',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.WHITE_LABEL_DOMAIN',
    value: 'general-domains?item=White Label Domain',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DOMAIN_ALIASES',
    value: 'general-domains?item=Domain Aliases',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.INTERNAL_DOMAINS',
    value: 'general → domain?item=Internal Domains',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.CNAME_TLS',
    value: 'general-domains?item=CNAME TLS',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.CNAME_HSTS',
    value: 'general-domains?item=CNAME HSTS',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.LOGO_URL',
    value: 'general-domains?item=Logo URL',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.FAVICON_URL',
    value: 'general-domains?item=Favicon URL',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.REDIRECT_URL',
    value: 'general-domains?item=Redirect URL',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_CDN_BETA',
    value: 'general-domains?item=Enable CDN Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.AUTO_INLINE_IMAGE_BUCKET_URLS',
    value: 'general-domains?item=Auto-Inline Image Bucket URLs Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.AUTO_INLINE_IMAGE_URLS',
    value: 'general-domains?item=Auto-Inline Image URLs',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DYNAMIC_GROUPS_BETA',
    value: 'general-domains?item=Dynamic Groups Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PGP_ENCRYPTION_CSV_SYNC',
    value: 'general-domains?item=PGP Encryption for CSV Sync',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ALLOW_SETTINGS_CLONING',
    value: 'general-domains?item=Allow Settings Cloning',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SUSPEND_SERVICE',
    value: 'general-domains?item=Suspend Service',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.NEW_UI',
    value: 'general-domains?item=New UI',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DEFAULT_TO_NEW_UI',
    value: 'general-domains?item=Default to New UI',
    group: 'label.DOMAIN_SEARCH.GENERAL_DOMAINS',
    permission: 'staff'
  },
  {
    value: 'General → Signatures',
    label: 'label.DOMAIN_SEARCH.GENERAL_SIGNATURES',
    id: 'General → Signatures',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURE_BLOCK_CODE',
    value: 'general-signatures?item=Signature Block Code',
    group: 'label.DOMAIN_SEARCH.GENERAL_SIGNATURES',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SIGNATUERS_ONLY',
    value: 'general-signatures?item=Signatures Only',
    group: 'label.DOMAIN_SEARCH.GENERAL_SIGNATURES',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURE_STAMPING',
    value: 'general-signatures?item=Signature Stamping',
    group: 'label.DOMAIN_SEARCH.GENERAL_SIGNATURES',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.QUOTED_SIGNATURE_BLOCKS',
    value: 'general-signatures?item=Quoted Signature Blocks',
    group: 'label.DOMAIN_SEARCH.GENERAL_SIGNATURES',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.FULL_SIGNATURE_ON_INITIAL_REPLY',
    value: 'general-signatures?item=Full Signature On Initial Reply',
    group: 'label.DOMAIN_SEARCH.GENERAL_SIGNATURES',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.TAG_PLACEMENT',
    value: 'general-signatures?item=Bottom Tag Placement',
    group: 'label.DOMAIN_SEARCH.GENERAL_SIGNATURES',
    permission: 'staff'
  },
  {
    value: 'General → Banners',
    label: 'label.DOMAIN_SEARCH.GENERAL_BANNERS',
    id: 'General → Banners',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DEFAULT_TO_BANNERS',
    value: 'general-banners?item=Default to Banners',
    group: 'label.DOMAIN_SEARCH.GENERAL_BANNERS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BANNER_STAMPING',
    value: 'general-banners?item=Banner Stamping',
    group: 'label.DOMAIN_SEARCH.GENERAL_BANNERS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DISABLE_BANNERS',
    value: 'general-banners?item=Disable Banners',
    group: 'label.DOMAIN_SEARCH.GENERAL_BANNERS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.INLINE_BANNERS',
    value: 'general-banners?item=Inline Banners',
    group: 'label.DOMAIN_SEARCH.GENERAL_BANNERS',
    permission: 'staff'
  },
  {
    value: 'General → Business Cards',
    label: 'label.DOMAIN_SEARCH.GENERAL_BUSINESS_CARDS',
    id: 'General → Business Cards',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_BUSINESS_CARDS',
    value: 'general-bizcards?item=Enable Business Cards',
    group: 'label.DOMAIN_SEARCH.GENERAL_BUSINESS_CARDS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PRIVATE_BUSINESS_CARDS',
    value: 'general-bizcards?item=Use Private Business Card URLs',
    group: 'label.DOMAIN_SEARCH.GENERAL_BUSINESS_CARDS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_VCARDS',
    value: 'general-bizcards?item=Enable vCards',
    group: 'label.DOMAIN_SEARCH.GENERAL_BUSINESS_CARDS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.VCARD_FIELD_MAPPINGS',
    value: 'general-bizcards?item=vCard Field Mappings',
    group: 'label.DOMAIN_SEARCH.GENERAL_BUSINESS_CARDS',
    permission: 'staff'
  },
  // {
  //   groupItem: true,
  //   label: 'Business Card HTML Template',
  //   value: 'general-bizcards?item=Business Card HTML Template',
  //   group: 'label.DOMAIN_SEARCH.GENERAL_BUSINESS_CARDS','
  //   permission: 'staff'
  // },
  // {
  //   groupItem: true,
  //   label: 'Manifest JSON Template (Optional)',
  //   value: 'general-bizcards?item=Manifest JSON Template (Optional)',
  //   group: 'label.DOMAIN_SEARCH.GENERAL_BUSINESS_CARDS','
  //   permission: 'staff'
  // },
  {
    value: 'General → Billing',
    label: 'label.DOMAIN_SEARCH.GENERAL_BILLING',
    id: 'General → Billing',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BILLING_WARNING',
    value: 'general-billing?item=Billing Warning',
    group: 'label.DOMAIN_SEARCH.GENERAL_BILLING',
    permission: 'staff'
  },
  {
    value: 'General → Email & Tracking',
    label: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    id: 'General → Email & Tracking',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ATTACHMENT_VIEW_DOWNLOAD_TEMPLATE',
    value: 'general-email?item=Attachment View/Download Template',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_ADVANCED_TEMPLATING_ENGINE_BETA',
    value: 'general-email?item=Enable Advanced Templating Engine Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_FROM_BLOCK_OVERRIDES_BETA',
    value: 'general-email?item=Enable [[from]] Block Overrides Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.USE_EMAIL_BODY_FROM_HEADER',
    value: 'general-email?item=Use Email Body From: header',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SLIDE_VIEW_MAX_TIME',
    value: 'general-email?item=Slide View Max Time',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.AUTO_TRACK_ATTACHMENT_X_MBYTES',
    value: 'general-email?item=Autotrack attachments &gt;= X Mbytes',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DOCUMENT_PLAYBACK_BETA',
    value: 'general-email?item=Document Playback Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DISABLE_INTERNAL_TRACKING',
    value: 'general-email?item=Disable Internal Tracking',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.REPLY_TRACKING',
    value: 'general-email?item=Reply Tracking',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DISABLE_MULTI_RECIPIENT_PROCESSING',
    value: 'general-email?item=Disable Multi-Recipient Processing',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_NON_SALES_USERS',
    value: 'general-email?item=Enable Non-Sales Users',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURE_COMPLIANCE_TRACKING_BETA',
    value: 'general-email?item=Signature Compliance Tracking Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DISABLE_METADATA',
    value: 'general-email?item=Disable Metadata',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_SURVEYS_FEATURE',
    value: 'general-email?item=Enable Surveys Feature',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.CLEAR_DUPLICATE_DISCLAIMERS',
    value: 'general-email?item=Clear Duplicate Disclaimers',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.S_MIME_PROCESSING',
    value: 'general-email?item=S/MIME Processing',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.GMAIL_AUTO_ELLIPSING',
    value: 'general-email?item=Gmail Auto-ellipsing',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.WEBSITE_TRACKING_BETA',
    value: 'general-email?item=Website Tracking Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.WEBSITE_SITE_PLAYBACK_BETA',
    value: 'general-email?item=Website Site Playback Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.INCLUDE_IPS_IN_FEEDS',
    value: 'general-email?item=Include IPs in Feeds',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.CONTACT_ENRICHMENT',
    value: 'general-email?item=Contact Enrichment',
    group: 'label.DOMAIN_SEARCH.GENERAL_EMAIL_AND_TRACKING',
    permission: 'staff'
  },
  {
    value: 'General → Users',
    label: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    id: 'General → Users',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.USE_DEFAULT_FIELDS',
    value: 'general-users?item=Use Default Fields',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.SALES_PRODUCTS',
    value: 'general-users?item=Sales Product',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.AUTO_TRACK_EMAILS',
    value: 'general-users?item=Auto Track Emails',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.AUTO_TRACK_LINKS',
    value: 'general-users?item=Auto Track Links',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.AUTO_TRACK_ATTACHMENTS',
    value: 'general-users?item=Auto Track Attachments',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.DWELL_TIME_BETA',
    value: 'general-users?item=Dwell Time Beta',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.ATTACHMENT_ICON',
    value: 'general-users?item=Attachment Icon',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.KEEP_ORIGINAL_ATTACHMENTS',
    value: 'general-users?item=Keep Original Attachments',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.ATTACHMENTS_AT_TOP',
    value: 'general-users?item=Attachments At Top',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.AUTO_BCC',
    value: 'general-users?item=Auto BCC',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.TRACK_AUTO_BCC',
    value: 'general-users?item=Track Auto BCC',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.DO_NOT_TRACK_LIST',
    value: 'general-users?item=Do Not Track List',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.SMART_ACTIVITY_FEED',
    value: 'general-users?item=Smart Activity Feed',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.TRACK_AUTO_FORWARDED_EMAILS',
    value: 'general-users?item=Track Auto Forwarded Emails',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.MULTI_RECIPIENT_TRACKING',
    value: 'general-users?item=Multi Recipient Tracking',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    label: 'label.USE_##_SHORTCUT',
    value: 'general-users?item=Use Shortcut',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.USE_DEFAULT_SETTINGS',
    value: 'general-users?item=Use Default Settings',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.USE_DEFAULT_NOTIFICATION_SETTINGS',
    value: 'general-users?item=Use Default Notification Settings',
    group: 'label.DOMAIN_SEARCH.GENERAL_USERS',
    permission: 'staff'
  },
  {
    value: 'General → Audit History',
    label: 'label.DOMAIN_SEARCH.GENERAL_AUDIT_HISTORY',
    id: 'General → Audit History',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_THIRD_PARTY_PUSH',
    value: 'general-audit-history?item=Enable 3rd-Party Push',
    group: 'label.DOMAIN_SEARCH.GENERAL_AUDIT_HISTORY',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.AUTHORIZATION_TOKEN',
    value: 'general-audit-history?item=Authorization Token',
    group: 'label.DOMAIN_SEARCH.GENERAL_AUDIT_HISTORY',
    permission: 'staff'
  },
  {
    value: 'General → Personas',
    label: 'label.DOMAIN_SEARCH.GENERAL_PERSONAS',
    id: 'General → Personas',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BUYER_ROLES',
    value: 'general-personas?item=Buyer Roles',
    group: 'label.DOMAIN_SEARCH.GENERAL_PERSONAS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BUYER_DEPARTMENTS',
    value: 'general-personas?item=Buyer Departments',
    group: 'label.DOMAIN_SEARCH.GENERAL_PERSONAS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.EXECUTIVE_KEYWORDS',
    value: 'general-personas?item=Executive Keywords',
    group: 'label.DOMAIN_SEARCH.GENERAL_PERSONAS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.INFLUENCER_KEYWORDS',
    value: 'general-personas?item=Influencer Keywords',
    group: 'label.DOMAIN_SEARCH.GENERAL_PERSONAS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.EXCLUDED_KEYWORDS',
    value: 'general-personas?item=Excluded Keywords',
    group: 'label.DOMAIN_SEARCH.GENERAL_PERSONAS',
    permission: 'staff'
  },
  {
    value: 'Routing',
    label: 'label.ROUTING',
    id: 'Routing',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.GENERAL',
    value: 'routing-general?item=General',
    group: 'label.ROUTING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SMART_HOST',
    value: 'routing-smart?item=Smart Host',
    group: 'label.ROUTING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BULK_HOST',
    value: 'routing-bulk?item=Bulk Host',
    group: 'label.ROUTING',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.RELAY',
    value: 'routing-relay?item=Relay',
    group: 'label.ROUTING',
    permission: 'staff'
  },
  {
    value: 'Routing → General',
    label: 'label.DOMAIN_SEARCH.ROUTING_GENERAL',
    id: 'Routing → General',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.LOOPBACK_ONLY',
    value: 'routing-general?item=Loopback Only',
    group: 'label.DOMAIN_SEARCH.ROUTING_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.MICROSOFT_365_HOSTNAME_OVERRIDE',
    value: 'routing-general?item=Microsoft 365 Hostname Override',
    group: 'label.DOMAIN_SEARCH.ROUTING_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_MICROSOFT_365',
    value: 'routing-general?item=Enable Microsoft 365',
    group: 'label.DOMAIN_SEARCH.ROUTING_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_MICROSOFT_GCC_HIGH',
    value: 'routing-general?item=Enable Microsoft GCC High',
    group: 'label.DOMAIN_SEARCH.ROUTING_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_GOOGLE',
    value: 'routing-general?item=Enable Google',
    group: 'label.DOMAIN_SEARCH.ROUTING_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_NEW_GOOGLE_POOL',
    value: 'routing-general?item=Enable New Google Pool',
    group: 'label.DOMAIN_SEARCH.ROUTING_GENERAL',
    permission: 'staff'
  },
  {
    value: 'Routing → Smart Host',
    label: 'label.DOMAIN_SEARCH.ROUTING_SMART_HOST',
    id: 'Routing → Smart Host',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SMART_HOSTING',
    value: 'routing-smart?item=Smart Hosting',
    group: 'label.DOMAIN_SEARCH.ROUTING_SMART_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.HOSTNAME',
    value: 'routing-smart?item=Hostname',
    group: 'label.DOMAIN_SEARCH.ROUTING_SMART_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PORT',
    value: 'routing-smart?item=Port',
    group: 'label.DOMAIN_SEARCH.ROUTING_SMART_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.USER',
    value: 'routing-smart?item=User',
    group: 'label.DOMAIN_SEARCH.ROUTING_SMART_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PASSWORD',
    value: 'routing-smart?item=Password',
    group: 'label.DOMAIN_SEARCH.ROUTING_SMART_HOST',
    permission: 'staff'
  },
  {
    value: 'Routing → Bulk Host',
    label: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    id: 'Routing → Bulk Host',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BULK_HOSTING',
    value: 'routing-bulk?item=Bulk Hosting',
    group: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SEND_OUTREACH_EMAIL_TO_BULK_HOST',
    value: 'routing-bulk?item=Send Outreach email to bulk host',
    group: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.HEADER_TRIGGER',
    value: 'routing-bulk?item=Header Trigger',
    group: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.HOST',
    value: 'routing-bulk?item=Host',
    group: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PORT',
    value: 'routing-bulk?item=Port',
    group: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.USER',
    value: 'routing-bulk?item=User',
    group: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PASSWORD',
    value: 'routing-bulk?item=Password',
    group: 'label.DOMAIN_SEARCH.ROUTING_BULK_HOST',
    permission: 'staff'
  },
  {
    value: 'Routing → Relay',
    label: 'label.DOMAIN_SEARCH.ROUTING_RELAY',
    id: 'Routing → Relay',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.HOST',
    value: 'routing-relay?item=Host',
    group: 'label.DOMAIN_SEARCH.ROUTING_RELAY',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.USER',
    value: 'routing-relay?item=User',
    group: 'label.DOMAIN_SEARCH.ROUTING_RELAY',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.PASSWORD',
    value: 'routing-relay?item=Password',
    group: 'label.DOMAIN_SEARCH.ROUTING_RELAY',
    permission: 'staff'
  },

  {
    value: 'Deliverabilty',
    label: 'label.DELIVERABILITY',
    id: 'Deliverabilty',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DMARC_ADMIN_EMAIL',
    value: 'deliverabilty?item=DMARC Admin Email',
    group: 'label.DELIVERABILITY',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DKIM_ENABLED',
    value: 'deliverabilty?item=DKIM Enabled',
    group: 'label.DELIVERABILITY',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DKIM_SELECTOR',
    value: 'deliverabilty?item=DKIM Selector',
    group: 'label.DELIVERABILITY',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DKIM_DNS_ENTRY',
    value: 'deliverabilty?item=DKIM DNS Entry',
    group: 'label.DELIVERABILITY',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SCL_AUTH_CODE',
    value: 'deliverabilty?item=SCL Auth Code',
    group: 'label.DELIVERABILITY',
    permission: 'staff'
  },

  {
    value: 'SSO',
    label: 'label.SSO',
    id: 'SSO',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.AUTHENTICATION',
    value: 'sso-authentication',
    group: 'label.SSO',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ROLE_BINDINGS',
    value: 'sso-bindings',
    group: 'label.SSO',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SAML',
    value: 'sso-saml',
    group: 'label.SSO',
    permission: 'staff'
  },

  {
    value: 'SSO → Authentication',
    label: 'label.DOMAIN_SEARCH.SSO_AUTHENTICATION',
    id: 'SSO → Authentication',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.LOCAL_PASSWORD',
    value: 'sso-authentication?item=Local Password',
    group: 'label.DOMAIN_SEARCH.SSO_AUTHENTICATION',
    permission: 'staff'
  },

  {
    groupItem: true,
    label: 'label.LOCAL_PASSWORD_2FA',
    value: 'sso-authentication?item=Local Password 2FA',
    group: 'label.DOMAIN_SEARCH.SSO_AUTHENTICATION',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.LOCAL_PASSWORD_COMPLEXITY',
    value: 'sso-authentication?item=Local Password Complexity',
    group: 'label.DOMAIN_SEARCH.SSO_AUTHENTICATION',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.MICROSOFT_365_SSO',
    value: 'sso-authentication?item=Microsoft 365 SSO',
    group: 'label.DOMAIN_SEARCH.SSO_AUTHENTICATION',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SALESFORCE_SSO',
    value: 'sso-authentication?item=Salesforce SSO',
    group: 'label.DOMAIN_SEARCH.SSO_AUTHENTICATION',
    permission: 'staff'
  },

  {
    value: 'SSO → Role Bindings',
    label: 'label.DOMAIN_SEARCH.SSO_ROLE_BINDINGS',
    id: 'SSO → Role Bindings',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ADMIN',
    value: 'sso-bindings?item=Admin',
    group: 'label.DOMAIN_SEARCH.SSO_ROLE_BINDINGS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.MARKETING',
    value: 'sso-bindings?item=Marketing',
    group: 'label.DOMAIN_SEARCH.SSO_ROLE_BINDINGS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURES',
    value: 'sso-bindings?item=Signatures',
    group: 'label.DOMAIN_SEARCH.SSO_ROLE_BINDINGS',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.TRANSFER_ROLE_BINDINGS',
    value: 'sso-bindings?item=Transfer Role Bindings',
    group: 'label.DOMAIN_SEARCH.SSO_ROLE_BINDINGS',
    permission: 'staff'
  },

  {
    value: 'SSO → SAML',
    label: 'label.DOMAIN_SEARCH.SSO_SAML',
    id: 'SSO → SAML',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_SAML',
    value: 'sso-saml?item=Enable SAML',
    group: 'label.DOMAIN_SEARCH.SSO_SAML',
    permission: 'staff'
  },

  {
    value: 'CRM',
    label: 'label.CRM',
    id: 'CRM',
    groupHeader: true,
    selectable: false
  },

  {
    groupItem: true,
    label: 'label.SALESFORCE',
    value: 'crm-salesforce',
    group: 'label.CRM'
  },
  {
    groupItem: true,
    label: 'label.SUREFIRE',
    value: 'crm-surefire',
    group: 'label.CRM'
  },
  {
    groupItem: true,
    label: 'label.TOTAL_EXPERT',
    value: 'crm-totalexpert',
    group: 'label.CRM'
  },

  {
    value: 'CRM → Salesforce',
    label: 'label.DOMAIN_SEARCH.CRM_SALESFORCE',
    id: 'CRM → Salesforce',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.SANDBOX_MODE',
    value: 'crm-salesforce?item=Sandbox Mode',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },
  {
    groupItem: true,
    label: 'label.AUTO_POPULATE_BCC',
    value: 'crm-salesforce?item=Auto-Populate BCC',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },
  {
    groupItem: true,
    label: 'label.AUTO_ENABLE_TRACKING',
    value: 'crm-salesforce?item=Auto-Enable Tracking',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },
  {
    groupItem: true,
    label: 'label.ADMIN_EMAIL',
    value: 'crm-salesforce?item=Admin Email',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },
  {
    groupItem: true,
    label: 'label.API_ENDPOINT',
    value: 'crm-salesforce?item=API Endpoint',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },
  {
    groupItem: true,
    label: 'label.USER_FIELD_LIST',
    value: 'crm-salesforce?item=User Field List',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },
  {
    groupItem: true,
    label: 'label.USER_FILTERS',
    value: 'crm-salesforce?item=User Filters',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },
  {
    groupItem: true,
    label: 'label.SYNC_INACTIVE_USERS',
    value: 'crm-salesforce?item=Sync Inactive Users',
    group: 'label.DOMAIN_SEARCH.CRM_SALESFORCE'
  },

  {
    value: 'CRM → Surefire',
    label: 'label.DOMAIN_SEARCH.CRM_SUREFIRE',
    id: 'CRM → Surefire',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.API_ENDPOINT',
    value: 'crm-surefire?item=API Endpoint',
    group: 'label.DOMAIN_SEARCH.CRM_SUREFIRE'
  },
  {
    groupItem: true,
    label: 'label.CLIENT_KEY',
    value: 'crm-surefire?item=Client Key',
    group: 'label.DOMAIN_SEARCH.CRM_SUREFIRE'
  },
  {
    groupItem: true,
    label: 'label.API_KEY',
    value: 'crm-surefire?item=API Key',
    group: 'label.DOMAIN_SEARCH.CRM_SUREFIRE'
  },

  {
    value: 'CRM → TotalExpert',
    label: 'label.DOMAIN_SEARCH.CRM_TOTAL_EXPERT',
    id: 'CRM → TotalExpert',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.API_ENDPOINT',
    value: 'crm-totalExpert?item=API Endpoint',
    group: 'label.DOMAIN_SEARCH.CRM_TOTAL_EXPERT'
  },
  {
    groupItem: true,
    label: 'label.CLIENT_ID',
    value: 'crm-totalExpert?item=Client ID',
    group: 'label.DOMAIN_SEARCH.CRM_TOTAL_EXPERT'
  },
  {
    groupItem: true,
    label: 'label.CLIENT_SECRET',
    value: 'crm-totalExpert?item=Client Secret',
    group: 'label.DOMAIN_SEARCH.CRM_TOTAL_EXPERT'
  },
  {
    groupItem: true,
    label: 'label.USER_FILTERS',
    value: 'crm-totalExpert?item=User Filters',
    group: 'label.DOMAIN_SEARCH.CRM_TOTAL_EXPERT'
  },

  {
    value: 'Marketing',
    label: 'label.MARKETING',
    id: 'Marketing',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.GENERAL',
    value: 'marketing',
    group: 'label.MARKETING'
  },

  {
    value: 'Marketing → General',
    label: 'label.DOMAIN_SEARCH.MARKETING_GENERAL',
    id: 'Marketing → General',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.CUSTOM_URL_PARAMETERS',
    value: 'marketing?item=Custom URL Parameters',
    group: 'label.DOMAIN_SEARCH.MARKETING_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.AD_TAGS',
    value: 'marketing?item=Ad Tags',
    group: 'label.DOMAIN_SEARCH.MARKETING_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.ASSET_FOLDERS',
    value: 'marketing?item=Asset Folders',
    group: 'label.DOMAIN_SEARCH.MARKETING_GENERAL'
  },

  {
    value: 'Compliance',
    label: 'label.COMPLIANCE',
    id: 'Compliance',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.GENERAL',
    value: 'compliance',
    group: 'label.COMPLIANCE',
    permission: 'staff'
  },

  {
    value: 'Compliance → General',
    label: 'label.DOMAIN_SEARCH.COMPLIANCE_GENERAL',
    id: 'Compliance → General',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.ACTIVE_TRACKING_COMPLIANCE',
    value: 'compliance?item=Active-Tracking Compliance',
    group: 'label.DOMAIN_SEARCH.COMPLIANCE_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.EMAIL_NON_COMPLIANCE_REPORT',
    value: 'compliance?item=Email Non-Compliance Report',
    group: 'label.DOMAIN_SEARCH.COMPLIANCE_GENERAL',
    permission: 'staff'
  },

  {
    value: 'Outlook Add-in',
    label: 'label.OUTLOOK_ADDIN',
    id: 'Outlook Add-in',
    permission: 'microsoft',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.GENERAL',
    value: 'outlook',
    group: 'label.OUTLOOK_ADDIN',
    permission: 'microsoft'
  },
  {
    value: 'Outlook Add-in → General',
    label: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    id: 'Outlook Add-in → General',
    groupHeader: true,
    selectable: false,
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.AUTOMATIC_SIGNATURES',
    value: 'outlook-general?item=Automatic Signatures',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.DEFAULT_SIGNATURE_MODE',
    value: 'outlook-general?item=Default Signature Mode',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.MULTIPLE_SIGNATURES',
    value: 'outlook-general?item=Multiple Signatures',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.PLAIN_TEXT_PREVIEW',
    value: 'outlook-general?item=Plain Text Preview',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.REMOVE_DEFAULT_SIGNATURE',
    value: 'outlook-general?item=Disable Default Signatures',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.USER_CONTROLLED_SETTINGS',
    value: 'outlook-general?item=User Controlled Settings',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.VISUAL_PREVIEW',
    value: 'outlook-general?item=Visual Preview',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.REMOVE_SIGNATURE_FOR_UNKNOWN_DOMAIN',
    value: 'outlook-general?item=Remove Signature for Unknown Domain',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.ALLOW_DEFAULT_OVERRIDE',
    value: 'outlook-general?item=Allow Default Override',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.ALLOW_DEFAULT_OVERRIDE_MUTLTI',
    value: 'outlook-general?item=Allow Default Override (Multiple Signature)',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.INLINE_IMAGES',
    value: 'outlook-general?item=Inline Images',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_GENERAL',
    permission: 'microsoft'
  },
  {
    value: 'Outlook Add-in → User & Signature Fields',
    label: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_USER_AND_SIGNATURE_FIELDS',
    id: 'Outlook Add-in → User & Signature Fields',
    permission: 'microsoft',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.DYNAMIC_FIELDS',
    value: 'outlook-fields?item=Dynamic Field Support',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_USER_AND_SIGNATURE_FIELDS',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.EDITABLE_FIELDS',
    value: 'outlook-fields?item=Editable Fields',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_USER_AND_SIGNATURE_FIELDS',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURE_FIELDS_ONLY',
    value: 'outlook-fields?item=Signature Fields Only',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_USER_AND_SIGNATURE_FIELDS',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.UI_HELPERS',
    value: 'outlook-fields?item=Custom Compose Fields',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_USER_AND_SIGNATURE_FIELDS',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.UI_HELPERS_CONFIGURATION',
    value: 'outlook-fields?item=Custom Compose Fields Configuration',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_USER_AND_SIGNATURE_FIELDS',
    permission: 'microsoft'
  },

  {
    value: 'Outlook Add-in → Email Tracking',
    label: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_EMAIL_TRACKING',
    id: 'Outlook Add-in → Email Tracking',
    groupHeader: true,
    selectable: false,
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.ACTIVITY_FEED',
    value: 'outlook-email-tracking?item=Activity Feed',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_EMAIL_TRACKING',
    permission: 'microsoft'
  },
  // {
  //   groupItem: true,
  //   label: 'label.DO_NOT_TRACK',
  //   value: 'outlook-email-tracking?item=Do Not Track',
  //   group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_EMAIL_TRACKING'
  // },

  {
    value: 'Outlook Add-in → Aliases & Shared Inboxes',
    label: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_ALIASES_AND_SHARED_INBOXES',
    id: 'Outlook Add-in → Aliases & Shared Inboxes',
    permission: 'microsoft',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.FROM_SWITCHING',
    value: 'outlook-shared?item=From Switching',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_ALIASES_AND_SHARED_INBOXES',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.IGNORE_EMPTY_FIELDS',
    value: 'outlook-shared?item=Ignore Empty Fields',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_ALIASES_AND_SHARED_INBOXES',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.MERGE_USER_FIELDS',
    value: 'outlook-shared?item=Merge User Fields',
    group: 'label.DOMAIN_SEARCH.OUTLOOK_ADDIN_ALIASES_AND_SHARED_INBOXES',
    permission: 'microsoft'
  },

  {
    value: 'Google Add-on → User & Signature Fields',
    label: 'label.DOMAIN_SEARCH.GOOGLE_ADDON_USER_AND_SIGNATURE_FIELDS',
    id: 'Google Add-on → User & Signature Fields',
    groupHeader: true,
    selectable: false,
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.UI_HELPERS',
    value: 'google-fields?item=Custom Compose Fields',
    group: 'label.DOMAIN_SEARCH.GOOGLE_ADDON_USER_AND_SIGNATURE_FIELDS',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.UI_HELPERS_CONFIGURATION',
    value: 'google-fields?item=Custom Compose Fields Configuration',
    group: 'label.DOMAIN_SEARCH.GOOGLE_ADDON_USER_AND_SIGNATURE_FIELDS',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURE_FIELDS_ONLY',
    value: 'google-fields?item=Signature Fields Only',
    group: 'label.DOMAIN_SEARCH.GOOGLE_ADDON_USER_AND_SIGNATURE_FIELDS',
    permission: 'google'
  },
  {
    value: 'My Signature',
    label: 'label.MY_SIGNATURE',
    id: 'My Signature',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.GENERAL',
    value: 'signature',
    group: 'label.MY_SIGNATURE'
  },

  {
    value: 'My Signature → General',
    label: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL',
    id: 'My Signature → General',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.MY_SIGNATURE',
    value: 'signature?item=My Signature',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.SIGNATURE_BLOCK_COPY',
    value: 'signature?item=Signature Block Copy',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.BANNER_BLOCK_COPY',
    value: 'signature?item=Banner Block Copy',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.MY_SIGNATURE_LINK',
    value: 'signature?item=My Signature Link',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.HELP_TEXT',
    value: 'signature?item=Help Text',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.BANNER_BLOCK_HELP_TEXT',
    value: 'signature?item=Banner Block Help Text',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.BANNER_BLOCK_DESCRIPTION_TEXT',
    value: 'signature?item=Banner Block Description Text',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.CUSTOM_FAQ_SECTION',
    value: 'signature?item=Custom FAQ Section',
    group: 'label.DOMAIN_SEARCH.MY_SIGNATURE_GENERAL'
  },

  {
    value: 'Directory/Sync',
    label: 'label.DIRECTORY_SYNC',
    id: 'Directory/Sync',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.GENERAL',
    value: 'directory-general',
    group: 'label.DIRECTORY_SYNC'
  },
  {
    groupItem: true,
    label: 'label.MICROSOFT_365',
    value: 'directory-microsoft',
    group: 'label.DIRECTORY_SYNC',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.GOOGLE_WORKSPACE',
    value: 'directory-google',
    group: 'label.DIRECTORY_SYNC',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'SFTP',
    value: 'directory-sftp',
    group: 'label.DIRECTORY_SYNC'
  },
  {
    groupItem: true,
    label: 'label.CUSTOM_DIRECTORY',
    value: 'directory-custom',
    group: 'label.DIRECTORY_SYNC'
  },
  {
    groupItem: true,
    label: 'label.CONFIGURATIONS',
    value: 'directory-configurations',
    group: 'label.DIRECTORY_SYNC'
  },
  {
    value: 'Directory/Sync → General',
    label: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL',
    id: 'Directory/Sync → General',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.FIELD_MAPPINGS',
    value: 'directory-general?item=Field Mappings',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.ENABLE_VCARDS',
    value: 'directory-general?item=Enable vCards',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.VCARD_FIELD_MAPPINGS',
    value: 'directory-general?item=VCard Field Mappings',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL',
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.BLANK_UNLOCKED_FIELDS_OVERRIDE',
    value: 'directory-general?item=Blank Unlocked Fields Override',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.DEFAULT_AUTO_SYNC_BEHAVIOR',
    value: 'directory-general?item=Default Auto-Sync Behavior',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.CSV_HIERARCHY_SYNCING',
    value: 'directory-general?item=CSV Hierarchy Syncing',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.CSV_SYSTEM_NAME',
    value: 'directory-general?item=CSV System Name',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL'
  },
  {
    groupItem: true,
    label: 'label.CSV_SYSTEM_ROOT_ID',
    value: 'directory-general?item=CSV System Root ID',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GENERAL'
  },

  {
    value: 'Directory/Sync → Google Workspace',
    label: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GOOGLE_WORKSPACE',
    id: 'Directory/Sync → Google Workspace',
    groupHeader: true,
    selectable: false,
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.GOOGLE_ADMIN_EMAIL',
    value: 'directory-google?item=Admin Email',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GOOGLE_WORKSPACE',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.AUTO_SYNC_USERS',
    value: 'directory-google?item=Auto-Sync Users',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GOOGLE_WORKSPACE',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.AUTO_SYNC_ORGS',
    value: 'directory-google?item=Auto-Sync Organizations',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GOOGLE_WORKSPACE',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.PHOTO_THUMBNAILS',
    value: 'directory-google?item=Photo Thumbnails',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GOOGLE_WORKSPACE',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.HIGH_RESOLUTION_THUMBNAILS_GOOGLE',
    value: 'directory-google?item=Photo Thumbnails',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GOOGLE_WORKSPACE',
    permission: 'google'
  },
  {
    groupItem: true,
    label: 'label.SYNC_ALIASES',
    value: 'directory-google?item=Sync Aliases',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_GOOGLE_WORKSPACE',
    permission: 'google'
  },
  {
    value: 'Directory/Sync → Microsoft 365',
    label: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    id: 'Directory/Sync → Microsoft 365',
    permission: 'microsoft',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.MICROSOFT_ADMIN_EMAIL',
    value: 'directory-microsoft?item=Admin Email',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.AUTO_SYNC_USERS',
    value: 'directory-microsoft?item=Auto-Sync Users',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.AUTO_SYNC_GROUPS',
    value: 'directory-microsoft?item=Auto-Sync Groups',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.CONTACT_FIELDS_SEARCH',
    value: 'directory-microsoft?item=Contact Fields Search',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.PHOTO_THUMBNAILS',
    value: 'directory-microsoft?item=Photo Thumbnails',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.SYNC_ALIASES',
    value: 'directory-microsoft?item=Sync Aliases',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.SYNC_MANAGERS',
    value: 'directory-microsoft?item=Sync Managers',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.USER_ODATA_FILTER',
    value: 'directory-microsoft?item=User OData Filter',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.USER_CLIENT_FILTER',
    value: 'directory-microsoft?item=User Client Filter',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.GROUP_ODATA_FILTER',
    value: 'directory-microsoft?item=Group OData Filter',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    groupItem: true,
    label: 'label.GROUP_FILTER',
    value: 'directory-microsoft?item=Group Filter',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_MICROSOFT_365',
    permission: 'microsoft'
  },
  {
    value: 'Directory/Sync → Custom Directory',
    label: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY',
    id: 'Directory/Sync → Custom Directory',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.API_KEY',
    value: 'directory-custom?item=API Key',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.API_ENDPOINT',
    value: 'directory-custom?item=API Endpoint',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.API_HTTP_METHOD',
    value: 'directory-custom?item=API HTTP Method',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.API_POST_CONTENT_TYPE',
    value: 'directory-custom?item=API POST Content-Type',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.API_POST_BODY',
    value: 'directory-custom?item=API POST Body',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.TOKEN_API_ENDPOINT',
    value: 'directory-custom?item=Token API Endpoint',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.TOKEN_HTTP_METHOD',
    value: 'directory-custom?item=Token HTTP Method',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.TOKEN_POST_CONTENT_TYPE',
    value: 'directory-custom?item=Token POST Content-Type',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.TOKEN_POST_BODY',
    value: 'directory-custom?item=Token POST Body',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.FORMAT',
    value: 'directory-custom?item=Format',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.RESULT_ARRAY_FIELD_NAME',
    value: 'directory-custom?item=Result Array Field Name',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.TOKEN_POST_CONTENT_TYPE',
    value: 'directory-custom?item=Token POST Content-Type',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.EMAIL_FIELD',
    value: 'directory-custom?item=Email Field',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.CHANGE_FINGERPRINT_FIELD',
    value: 'directory-custom?item=Change Fingerprint Field',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.AUTHENTICATION_HEADER',
    value: 'directory-custom?item=Authentication Header',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },
  {
    groupItem: true,
    label: 'label.AUTO_SYNC_USERS',
    value: 'directory-custom?item=Auto-Sync Users',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CUSTOM_DIRECTORY'
  },

  {
    value: 'Directory/Sync → Configurations',
    label: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS',
    id: 'Directory/Sync → Configurations',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.AIRTABLE',
    value: 'directory-configurations?item=Airtable',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.BAMBOOHR',
    value: 'directory-configurations?item=BambooHR',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.CALENDLY',
    value: 'directory-configurations?item=Calendly',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.FRONTAPP',
    value: 'directory-configurations?item=Front',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.FTP_USERS',
    value: 'directory-configurations?item=FTP Users',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.JUMPCLOUD',
    value: 'directory-configurations?item=JumpCloud',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.MANGOAPPS',
    value: 'directory-configurations?item=MangoApps',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.OKTA',
    value: 'directory-configurations?item=OKTA',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.ONELOGIN',
    value: 'directory-configurations?item=OneLogin',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.OUTREACH',
    value: 'directory-configurations?item=Outreach',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.PINGBOARD',
    value: 'directory-configurations?item=PingBoard',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.SALESFORCE',
    value: 'directory-configurations?item=Salesforce',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.SUREFIRE_CRM',
    value: 'directory-configurations?item=Surefire CRM',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    groupItem: true,
    label: 'label.TOTAL_EXPERT',
    value: 'directory-configurations?item=TotalExpert',
    group: 'label.DOMAIN_SEARCH.DIRECTORY_SYNC_CONFIGURATIONS'
  },
  {
    value: 'Integrations',
    label: 'label.INTEGRATIONS',
    id: 'Integrations',
    groupHeader: true,
    selectable: false
  },
  {
    groupItem: true,
    label: 'label.CALENDLY',
    value: 'integrations-calendly?item=Calendly',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_CALENDLY'
  },
  {
    groupItem: true,
    label: 'label.DRIFT',
    value: 'integrations-drift?item=Drift',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_DRIFT'
  },
  {
    groupItem: true,
    label: 'label.ELOQUA',
    value: 'integrations-eloqua?item=Eloqua',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_ELOQUA'
  },
  {
    groupItem: true,
    label: 'label.HUBSPOT',
    value: 'integrations-hubspot?item=HubSpot',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_HUBSPOT'
  },
  {
    groupItem: true,
    label: 'label.MARKETO',
    value: 'integrations-marketo?item=Marketo',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_MARKETO'
  },
  {
    groupItem: true,
    label: 'label.OUTREACH',
    value: 'integrations-outreach?item=Outreach',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_OUTREACH'
  },
  {
    groupItem: true,
    label: 'label.PARDOT',
    value: 'integrations-pardot?item=Pardot',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_PARDOT'
  },
  {
    groupItem: true,
    label: 'label.ROLLWORKS',
    value: 'integrations-rollworks?item=RollWorks',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_ROLLWORKS'
  },
  {
    groupItem: true,
    label: 'label.SALESLOFT',
    value: 'integrations-salesloft?item=Salesloft',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_SALESLOFT'
  },
  {
    groupItem: true,
    label: 'label.UKG',
    value: 'integrations-ukg?item=UKG',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_UKG'
  },
  {
    groupItem: true,
    label: 'label.ZAPIER',
    value: 'integrations-zapier?item=Zapier',
    group: 'label.DOMAIN_SEARCH.INTEGRATIONS_ZAPIER'
  },

  {
    value: 'diagnostics',
    label: 'label.DIAGNOSTICS',
    id: 'diagnostics',
    groupHeader: true,
    selectable: false,
    permission: 'staff'
  },
  {
    groupItem: true,
    label: 'label.DIAGNOSTICS',
    value: 'diagnostics',
    group: 'label.GENERAL',
    permission: 'staff'
  }
];

// export const DOMAIN_SETTINGS_SEARCH = DOMAIN_CATEGORIES.map(category => {
//   let items = [];

//   if (category.items) {
//     items = category.items;
//   }

//   return [category, ...items];
// }).flat().map(category => ({
//   label: category.label,
//   value: category.id,
//   group: category.id.split('-')[0]
// }));

// console.log(DOMAIN_SETTINGS_SEARCH)

// [
//   {
//     label: 'White Label Domain',
//     value: 'general-domains'
//   }, {
//     label: 'Domain Aliases',
//     value: 'general-domains'
//   }, {
//     label: 'Internal Domains',
//     value: 'general-domains'
//   }, {
//     label: 'CNAME TLS',
//     value: 'general-domains'
//   }, {
//     label: 'Google Workspace Admin Email',
//     value: 'general-domains'
//   }, {
//     label: 'Logo URL',
//     value: 'general-domains'
//   }, {
//     label: 'Favicon URL',
//     value: 'general-domains'
//   }, {
//     label: 'Redirect URL',
//     value: 'general-domains'
//   }, {
//     label: 'Enable CDN Beta',
//     value: 'general-domains'
//   }, {
//     label: 'Auto-Inline Image Bucket URLs Beta',
//     value: 'general-domains'
//   }, {
//     label: 'Auto-Inline Image URLs',
//     value: 'general-domains'
//   }, {
//     label: 'Auto-Inline Image Bucket URLs Beta',
//     value: 'general-domains'
//   }, {
//     label: 'Dynamic Groups Beta',
//     value: 'general-domains'
//   }, {
//     label: 'PGP Encryption for CSV Sync',
//     value: 'general-domains'
//   }, {
//     label: 'Allow Settings Cloning',
//     value: 'general-domains'
//   }, {
//     label: 'VCard Field Mappings',
//     value: 'general-domains'
//   }
// ]
